"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button = __importStar(require("./A_Button"));
/**
 * A molecule containing a brief text explanation over a MUI LoadingButton
 *
 * Created for AR runway before atomic design UI refresh. Avoid reuse.
 */
var Component = function (_a) {
    var buttonText = _a.buttonText, explanation = _a.explanation, Icon = _a.Icon, error = _a.error, onClick = _a.onClick, loading = _a.loading, disabled = _a.disabled;
    return (Preact.h(Preact.Fragment, null,
        Preact.h(Typography_1.default, { variant: "h4", component: "p", sx: {
                textAlign: 'center',
            } }, explanation),
        Preact.h(Button.Component, { color: "primary", variant: "contained", size: "medium", fullWidth: true, startIcon: Icon ? Preact.h(Icon, null) : undefined, loading: loading, disabled: disabled !== null && disabled !== void 0 ? disabled : false, onClick: onClick, sx: { mt: 3 }, classes: {} }, buttonText),
        error === undefined ? (Preact.h(Preact.Fragment, null)) : (Preact.h(Typography_1.default, { sx: { px: 3, pb: 0, pt: 2, textAlign: 'center', color: 'error.main' } }, error))));
};
exports.Component = Component;
